/**
 * "Needs a narrative" placeholder handling. The backend reserves the exact
 * string "Please fill in the narrative." as a stub sentinel, and the smart
 * timer creates entries like "Timer started 4:05 PM. Please fill in the
 * narrative." Both should read as a muted placeholder in the UI (a dull hint,
 * not real content) so an attorney can just type over it without deleting.
 */
export const NARRATIVE_PLACEHOLDER_PHRASE = "Please fill in the narrative";

/** The exact "no narrative yet" sentinel the tracker (and now the timer) use. */
export const NARRATIVE_PLACEHOLDER = "Please fill in the narrative.";

export function isNarrativePlaceholder(
	description: string | null | undefined,
): boolean {
	return (
		typeof description === "string" &&
		description.includes(NARRATIVE_PLACEHOLDER_PHRASE)
	);
}
